import React from "react";
import { Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";

import BreadcrumbAndTitle from "@components/BreadcrumbAndTitle";
import { BreadcrumbChild } from "@components/BreadcrumbCustom";

import ROUTES from "@config/routes";

import NotificationFormikContainer from "../resource/form/NotificationFormikContainer";
import { NotificationFormModeEnum } from "../resource/form/hook/interface";

interface RouteParams {
  id?: string;
}

const EditNotification: React.FC = () => {
  const { id } = useParams<RouteParams>();

  const breadcrumbData: BreadcrumbChild[] = [
    { label: "Início", link: ROUTES.ADMIN_ROUTES.HOME },
    { label: "Notificações", link: ROUTES.ADMIN_ROUTES.NOTIFICATIONS.ROOT },
    { label: id ? `Editar #${id}` : "Editar" },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <BreadcrumbAndTitle
          breadcrumbData={breadcrumbData}
          title={id ? `Editar notificação #${id}` : "Editar notificação"}
        />
      </Grid>

      <Grid item xs={12}>
        <NotificationFormikContainer mode={NotificationFormModeEnum.EDIT} />
      </Grid>
    </Grid>
  );
};

export default EditNotification;
